import {
  Cancel as CancelIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
} from '@material-ui/icons';

// eslint-disable-next-line
export const statusIcons = {
  agreed: CheckCircleIcon,
  notAgreed: CancelIcon,
  noDecision: WarningIcon,
};
